import { FaMapMarkerAlt } from 'react-icons/fa'

interface DistanceFromYouProps {
  distance: number
  className?: string
  reloadProfile?: () => void
}

export function DistanceFromYou({
  className,
  distance,
  reloadProfile,
}: DistanceFromYouProps) {
  const requestLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords
          localStorage.setItem(
            'userLocation',
            JSON.stringify({ latitude, longitude }),
          )
          reloadProfile()
        },
        (error) => {
          if (error.code === 1) {
            alert(
              'Please enable location in your browser settings to see how far this lawyer is from you.',
            )
          } else {
            console.error('Error getting location:', error)
          }
        },
      )
    } else {
      alert('Geolocation is not supported by this browser.')
    }
  }

  return (
    <div className={`${className} flex gap-1`}>
      <FaMapMarkerAlt color='#001A3D' className='h-4 w-4' />
      <p className='text-[#001A3D] text-[10px] md:text-xs'>
        {distance === -1 ? (
          'Unknown location'
        ) : (
          <>
            {distance === -2 ? (
              <button
                onClick={requestLocation}
                className='underline text-blue-500'
              >
                Unknown
              </button>
            ) : (
              `${distance}`
            )}
            &nbsp;miles from you
          </>
        )}
      </p>
    </div>
  )
}
